<router-outlet></router-outlet>
<ngx-spinner 
    bdColor="rgba(0,0,0,0.7)" 
    size="medium" 
    color="#afca0d"
    type="cube-transition" 
    [fullScreen]="true">
</ngx-spinner>